import React, { useMemo, useState } from 'react';
import { Plus } from 'lucide-react';
import { ExportMenu } from '../components/export/ExportMenu';
import { StudentTable } from '../components/students/StudentTable';
import { StudentTableSkeleton } from '../components/students/StudentTableSkeleton';
import { StudentToolbar, type StudentFilters } from '../components/students/StudentToolbar';
import { StudentsEmptyState } from '../components/students/StudentsEmptyState';
import { Button } from '../components/ui/Button';
import { useStudents } from '../contexts/StudentsContext';
import { filterStudents, sortStudents, uniqueClasses } from '../utils/stats';
const initialFilters: StudentFilters = {
  search: '',
  sort: 'newest',
  gender: '',
  className: ''
};
export function Students() {
  const {
    students,
    loading,
    openCreateForm
  } = useStudents();
  const [filters, setFilters] = useState<StudentFilters>(initialFilters);
  const classes = useMemo(() => uniqueClasses(students), [students]);
  const visible = useMemo(() => sortStudents(filterStudents(students, filters.search, filters.gender, filters.className), filters.sort), [students, filters]);
  return <div className="mx-auto w-full max-w-7xl space-y-5" data-id="element-688" data-mp="2pe07sblpqy3h">
      <section className="glass flex flex-col gap-4 rounded-3xl p-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-689" data-mp="2ue4mpx6z3krl">
        <div data-id="element-690" data-mp="2z7gxp4iqbt1v">
          <h2 className="text-xl font-semibold tracking-tight text-foreground sm:text-2xl" data-id="element-691" data-mp="2z7z4gv30ppo1">Student records</h2>
          <p className="mt-1.5 text-sm text-muted-foreground" data-id="element-692" data-mp="347bpdaabwmnz">
            Streaming live from the Firestore <span className="font-mono" data-id="element-693" data-mp="395wrxgd1zifl">students</span> collection — every change
            appears instantly.
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2" data-id="element-694" data-mp="3i50belg4tzum">
          <ExportMenu data-id="element-695" data-mp="3i2e5eq8w3sei" />
          <Button onClick={openCreateForm} className="h-9 rounded-xl brand-gradient px-4 text-white shadow-lg shadow-indigo-500/25 hover:opacity-95" data-id="element-696" data-mp="1irw7ig4lr6mk">
            <Plus className="mr-1.5 h-4 w-4" data-id="element-697" data-mp="2r1n06istpjnr" />
            Add Student
          </Button>
        </div>
      </section>

      <section className="glass overflow-hidden rounded-3xl" aria-label="Student records table" data-id="element-698" data-mp="2m33aq8f0tpqn">
        <StudentToolbar filters={filters} onChange={setFilters} classes={classes} resultCount={visible.length} totalCount={students.length} data-id="element-699" data-mp="302ukty2f2lzd" />

        {loading ? <StudentTableSkeleton data-id="element-700" data-mp="39zh5omuqtd1e" /> : students.length === 0 ? <StudentsEmptyState variant="no-records" onAddStudent={openCreateForm} data-id="element-701" data-mp="351xqnkq80w8e" /> : visible.length === 0 ? <StudentsEmptyState variant="no-matches" onAddStudent={openCreateForm} onClearFilters={() => setFilters(initialFilters)} data-id="element-702" data-mp="3irreq0twjch2" /> : <StudentTable students={visible} data-id="element-703" data-mp="3sq79cds513vb" />}
      </section>
    </div>;
}